export default [
    {
        lat: 47.605,
        lng: 9.595,
    },
    {
        lat: 47.605,
        lng: 9.615,
    },
    {
        lat: 47.625,
        lng: 9.63,
    },
    {
        lat: 47.63,
        lng: 9.65,
    },
    {
        lat: 47.625,
        lng: 9.715,
    },
    {
        lat: 47.635,
        lng: 9.725,
    },
    {
        lat: 47.635,
        lng: 9.755,
    },
    {
        lat: 47.65,
        lng: 9.775,
    },
    {
        lat: 47.665,
        lng: 9.78,
    },
    {
        lat: 47.67,
        lng: 9.81,
    },
    {
        lat: 47.69,
        lng: 9.82,
    },
    {
        lat: 47.7,
        lng: 9.845,
    },
    {
        lat: 47.695,
        lng: 9.885,
    },
    {
        lat: 47.68,
        lng: 9.9,
    },
    {
        lat: 47.675,
        lng: 9.93,
    },
    {
        lat: 47.675,
        lng: 9.96,
    },
    {
        lat: 47.7,
        lng: 9.985,
    },
    {
        lat: 47.71,
        lng: 10.025,
    },
    {
        lat: 47.7,
        lng: 10.045,
    },
    {
        lat: 47.7,
        lng: 10.07,
    },
    {
        lat: 47.69,
        lng: 10.075,
    },
    {
        lat: 47.695,
        lng: 10.085,
    },
    {
        lat: 47.69,
        lng: 10.11,
    },
    {
        lat: 47.7,
        lng: 10.11,
    },
    {
        lat: 47.71,
        lng: 10.095,
    },
    {
        lat: 47.745,
        lng: 10.095,
    },
    {
        lat: 47.75,
        lng: 10.075,
    },
    {
        lat: 47.765,
        lng: 10.065,
    },
    {
        lat: 47.775,
        lng: 10.045,
    },
    {
        lat: 47.795,
        lng: 10.045,
    },
    {
        lat: 47.825,
        lng: 10.085,
    },
    {
        lat: 47.865,
        lng: 10.055,
    },
    {
        lat: 47.91,
        lng: 10.085,
    },
    {
        lat: 47.93,
        lng: 10.085,
    },
    {
        lat: 47.945,
        lng: 10.065,
    },
    {
        lat: 47.97,
        lng: 10.065,
    },
    {
        lat: 47.99,
        lng: 10.08,
    },
    {
        lat: 48,
        lng: 10.1,
    },
    {
        lat: 48.015,
        lng: 10.1,
    },
    {
        lat: 48.02,
        lng: 10.11,
    },
    {
        lat: 48.045,
        lng: 10.11,
    },
    {
        lat: 48.05,
        lng: 10.12,
    },
    {
        lat: 48.07,
        lng: 10.115,
    },
    {
        lat: 48.09,
        lng: 10.12,
    },
    {
        lat: 48.105,
        lng: 10.11,
    },
    {
        lat: 48.11,
        lng: 10.095,
    },
    {
        lat: 48.15,
        lng: 10.075,
    },
    {
        lat: 48.195,
        lng: 10.065,
    },
    {
        lat: 48.24,
        lng: 10.04,
    },
    {
        lat: 48.275,
        lng: 10.04,
    },
    {
        lat: 48.345,
        lng: 9.975,
    },
    {
        lat: 48.345,
        lng: 9.965,
    },
    {
        lat: 48.36,
        lng: 9.95,
    },
    {
        lat: 48.375,
        lng: 9.945,
    },
    {
        lat: 48.395,
        lng: 9.955,
    },
    {
        lat: 48.415,
        lng: 9.995,
    },
    {
        lat: 48.435,
        lng: 10.01,
    },
    {
        lat: 48.465,
        lng: 10.01,
    },
    {
        lat: 48.48,
        lng: 10.03,
    },
    {
        lat: 48.475,
        lng: 10.05,
    },
    {
        lat: 48.48,
        lng: 10.075,
    },
    {
        lat: 48.5,
        lng: 10.105,
    },
    {
        lat: 48.495,
        lng: 10.125,
    },
    {
        lat: 48.475,
        lng: 10.14,
    },
    {
        lat: 48.475,
        lng: 10.15,
    },
    {
        lat: 48.49,
        lng: 10.165,
    },
    {
        lat: 48.505,
        lng: 10.205,
    },
    {
        lat: 48.52,
        lng: 10.21,
    },
    {
        lat: 48.53,
        lng: 10.225,
    },
    {
        lat: 48.54,
        lng: 10.25,
    },
    {
        lat: 48.535,
        lng: 10.28,
    },
    {
        lat: 48.55,
        lng: 10.28,
    },
    {
        lat: 48.56,
        lng: 10.29,
    },
    {
        lat: 48.57,
        lng: 10.29,
    },
    {
        lat: 48.58,
        lng: 10.275,
    },
    {
        lat: 48.615,
        lng: 10.28,
    },
    {
        lat: 48.63,
        lng: 10.255,
    },
    {
        lat: 48.655,
        lng: 10.235,
    },
    {
        lat: 48.685,
        lng: 10.235,
    },
    {
        lat: 48.7,
        lng: 10.25,
    },
    {
        lat: 48.72,
        lng: 10.255,
    },
    {
        lat: 48.725,
        lng: 10.275,
    },
    {
        lat: 48.72,
        lng: 10.295,
    },
    {
        lat: 48.71,
        lng: 10.3,
    },
    {
        lat: 48.71,
        lng: 10.34,
    },
    {
        lat: 48.685,
        lng: 10.365,
    },
    {
        lat: 48.72,
        lng: 10.4,
    },
    {
        lat: 48.72,
        lng: 10.42,
    },
    {
        lat: 48.74,
        lng: 10.395,
    },
    {
        lat: 48.755,
        lng: 10.4,
    },
    {
        lat: 48.775,
        lng: 10.39,
    },
    {
        lat: 48.785,
        lng: 10.4,
    },
    {
        lat: 48.815,
        lng: 10.405,
    },
    {
        lat: 48.82,
        lng: 10.415,
    },
    {
        lat: 48.845,
        lng: 10.405,
    },
    {
        lat: 48.87,
        lng: 10.43,
    },
    {
        lat: 48.9,
        lng: 10.4,
    },
    {
        lat: 48.92,
        lng: 10.405,
    },
    {
        lat: 48.93,
        lng: 10.42,
    },
    {
        lat: 48.955,
        lng: 10.385,
    },
    {
        lat: 48.97,
        lng: 10.38,
    },
    {
        lat: 48.99,
        lng: 10.385,
    },
    {
        lat: 49,
        lng: 10.405,
    },
    {
        lat: 49.02,
        lng: 10.41,
    },
    {
        lat: 49.03,
        lng: 10.44,
    },
    {
        lat: 49.025,
        lng: 10.51,
    },
    {
        lat: 49.055,
        lng: 10.55,
    },
    {
        lat: 49.055,
        lng: 10.605,
    },
    {
        lat: 49.04,
        lng: 10.62,
    },
    {
        lat: 49.03,
        lng: 10.66,
    },
    {
        lat: 49.005,
        lng: 10.665,
    },
    {
        lat: 49,
        lng: 10.685,
    },
    {
        lat: 48.98,
        lng: 10.695,
    },
    {
        lat: 48.965,
        lng: 10.715,
    },
    {
        lat: 48.94,
        lng: 10.72,
    },
    {
        lat: 48.945,
        lng: 10.765,
    },
    {
        lat: 48.97,
        lng: 10.8,
    },
    {
        lat: 48.97,
        lng: 10.825,
    },
    {
        lat: 48.94,
        lng: 10.845,
    },
    {
        lat: 48.915,
        lng: 10.85,
    },
    {
        lat: 48.915,
        lng: 10.87,
    },
    {
        lat: 48.9,
        lng: 10.88,
    },
    {
        lat: 48.9,
        lng: 10.92,
    },
    {
        lat: 48.88,
        lng: 10.955,
    },
    {
        lat: 48.88,
        lng: 10.995,
    },
    {
        lat: 48.86,
        lng: 11.005,
    },
    {
        lat: 48.85,
        lng: 11.02,
    },
    {
        lat: 48.83,
        lng: 11.025,
    },
    {
        lat: 48.815,
        lng: 11.025,
    },
    {
        lat: 48.8,
        lng: 11.005,
    },
    {
        lat: 48.78,
        lng: 11.005,
    },
    {
        lat: 48.77,
        lng: 11.02,
    },
    {
        lat: 48.745,
        lng: 11.015,
    },
    {
        lat: 48.735,
        lng: 11.025,
    },
    {
        lat: 48.72,
        lng: 11.025,
    },
    {
        lat: 48.705,
        lng: 11.01,
    },
    {
        lat: 48.695,
        lng: 11.01,
    },
    {
        lat: 48.675,
        lng: 11.025,
    },
    {
        lat: 48.66,
        lng: 11.055,
    },
    {
        lat: 48.625,
        lng: 11.06,
    },
    {
        lat: 48.63,
        lng: 11.12,
    },
    {
        lat: 48.615,
        lng: 11.14,
    },
    {
        lat: 48.615,
        lng: 11.165,
    },
    {
        lat: 48.59,
        lng: 11.185,
    },
    {
        lat: 48.56,
        lng: 11.18,
    },
    {
        lat: 48.545,
        lng: 11.22,
    },
    {
        lat: 48.505,
        lng: 11.245,
    },
    {
        lat: 48.505,
        lng: 11.26,
    },
    {
        lat: 48.49,
        lng: 11.27,
    },
    {
        lat: 48.495,
        lng: 11.31,
    },
    {
        lat: 48.48,
        lng: 11.325,
    },
    {
        lat: 48.435,
        lng: 11.325,
    },
    {
        lat: 48.425,
        lng: 11.31,
    },
    {
        lat: 48.425,
        lng: 11.27,
    },
    {
        lat: 48.41,
        lng: 11.245,
    },
    {
        lat: 48.41,
        lng: 11.22,
    },
    {
        lat: 48.405,
        lng: 11.215,
    },
    {
        lat: 48.38,
        lng: 11.22,
    },
    {
        lat: 48.36,
        lng: 11.2,
    },
    {
        lat: 48.35,
        lng: 11.2,
    },
    {
        lat: 48.35,
        lng: 11.19,
    },
    {
        lat: 48.34,
        lng: 11.195,
    },
    {
        lat: 48.32,
        lng: 11.19,
    },
    {
        lat: 48.305,
        lng: 11.17,
    },
    {
        lat: 48.3,
        lng: 11.145,
    },
    {
        lat: 48.255,
        lng: 11.135,
    },
    {
        lat: 48.24,
        lng: 11.11,
    },
    {
        lat: 48.245,
        lng: 11.085,
    },
    {
        lat: 48.24,
        lng: 11.075,
    },
    {
        lat: 48.18,
        lng: 11.075,
    },
    {
        lat: 48.17,
        lng: 11.04,
    },
    {
        lat: 48.185,
        lng: 11,
    },
    {
        lat: 48.18,
        lng: 10.95,
    },
    {
        lat: 48.19,
        lng: 10.93,
    },
    {
        lat: 48.21,
        lng: 10.92,
    },
    {
        lat: 48.18,
        lng: 10.91,
    },
    {
        lat: 48.165,
        lng: 10.89,
    },
    {
        lat: 48.155,
        lng: 10.89,
    },
    {
        lat: 48.14,
        lng: 10.875,
    },
    {
        lat: 48.14,
        lng: 10.865,
    },
    {
        lat: 48.125,
        lng: 10.85,
    },
    {
        lat: 48.13,
        lng: 10.815,
    },
    {
        lat: 48.115,
        lng: 10.835,
    },
    {
        lat: 48.09,
        lng: 10.835,
    },
    {
        lat: 48.06,
        lng: 10.805,
    },
    {
        lat: 48.04,
        lng: 10.835,
    },
    {
        lat: 47.985,
        lng: 10.845,
    },
    {
        lat: 47.92,
        lng: 10.81,
    },
    {
        lat: 47.875,
        lng: 10.81,
    },
    {
        lat: 47.855,
        lng: 10.79,
    },
    {
        lat: 47.835,
        lng: 10.79,
    },
    {
        lat: 47.815,
        lng: 10.775,
    },
    {
        lat: 47.805,
        lng: 10.775,
    },
    {
        lat: 47.79,
        lng: 10.8,
    },
    {
        lat: 47.76,
        lng: 10.8,
    },
    {
        lat: 47.745,
        lng: 10.785,
    },
    {
        lat: 47.745,
        lng: 10.76,
    },
    {
        lat: 47.72,
        lng: 10.755,
    },
    {
        lat: 47.72,
        lng: 10.77,
    },
    {
        lat: 47.735,
        lng: 10.78,
    },
    {
        lat: 47.745,
        lng: 10.8,
    },
    {
        lat: 47.75,
        lng: 10.83,
    },
    {
        lat: 47.74,
        lng: 10.845,
    },
    {
        lat: 47.715,
        lng: 10.85,
    },
    {
        lat: 47.68,
        lng: 10.815,
    },
    {
        lat: 47.69,
        lng: 10.85,
    },
    {
        lat: 47.675,
        lng: 10.885,
    },
    {
        lat: 47.68,
        lng: 10.925,
    },
    {
        lat: 47.655,
        lng: 10.94,
    },
    {
        lat: 47.645,
        lng: 10.935,
    },
    {
        lat: 47.63,
        lng: 10.97,
    },
    {
        lat: 47.61,
        lng: 10.975,
    },
    {
        lat: 47.58,
        lng: 10.955,
    },
    {
        lat: 47.565,
        lng: 10.93,
    },
    {
        lat: 47.56,
        lng: 10.9,
    },
    {
        lat: 47.52,
        lng: 10.9,
    },
    {
        lat: 47.515,
        lng: 10.86,
    },
    {
        lat: 47.505,
        lng: 10.845,
    },
    {
        lat: 47.51,
        lng: 10.83,
    },
    {
        lat: 47.5,
        lng: 10.82,
    },
    {
        lat: 47.495,
        lng: 10.765,
    },
    {
        lat: 47.51,
        lng: 10.745,
    },
    {
        lat: 47.52,
        lng: 10.745,
    },
    {
        lat: 47.52,
        lng: 10.705,
    },
    {
        lat: 47.54,
        lng: 10.67,
    },
    {
        lat: 47.545,
        lng: 10.6,
    },
    {
        lat: 47.525,
        lng: 10.595,
    },
    {
        lat: 47.515,
        lng: 10.58,
    },
    {
        lat: 47.515,
        lng: 10.51,
    },
    {
        lat: 47.53,
        lng: 10.465,
    },
    {
        lat: 47.505,
        lng: 10.46,
    },
    {
        lat: 47.5,
        lng: 10.475,
    },
    {
        lat: 47.48,
        lng: 10.49,
    },
    {
        lat: 47.42,
        lng: 10.495,
    },
    {
        lat: 47.4,
        lng: 10.455,
    },
    {
        lat: 47.37,
        lng: 10.455,
    },
    {
        lat: 47.36,
        lng: 10.445,
    },
    {
        lat: 47.365,
        lng: 10.425,
    },
    {
        lat: 47.36,
        lng: 10.41,
    },
    {
        lat: 47.345,
        lng: 10.405,
    },
    {
        lat: 47.335,
        lng: 10.385,
    },
    {
        lat: 47.32,
        lng: 10.37,
    },
    {
        lat: 47.31,
        lng: 10.37,
    },
    {
        lat: 47.285,
        lng: 10.34,
    },
    {
        lat: 47.285,
        lng: 10.315,
    },
    {
        lat: 47.25,
        lng: 10.24,
    },
    {
        lat: 47.255,
        lng: 10.225,
    },
    {
        lat: 47.25,
        lng: 10.165,
    },
    {
        lat: 47.28,
        lng: 10.15,
    },
    {
        lat: 47.3,
        lng: 10.155,
    },
    {
        lat: 47.315,
        lng: 10.17,
    },
    {
        lat: 47.315,
        lng: 10.18,
    },
    {
        lat: 47.335,
        lng: 10.18,
    },
    {
        lat: 47.365,
        lng: 10.2,
    },
    {
        lat: 47.365,
        lng: 10.19,
    },
    {
        lat: 47.35,
        lng: 10.175,
    },
    {
        lat: 47.345,
        lng: 10.155,
    },
    {
        lat: 47.35,
        lng: 10.12,
    },
    {
        lat: 47.335,
        lng: 10.11,
    },
    {
        lat: 47.335,
        lng: 10.09,
    },
    {
        lat: 47.39,
        lng: 10.065,
    },
    {
        lat: 47.39,
        lng: 10.055,
    },
    {
        lat: 47.4,
        lng: 10.05,
    },
    {
        lat: 47.42,
        lng: 10.05,
    },
    {
        lat: 47.435,
        lng: 10.065,
    },
    {
        lat: 47.455,
        lng: 10.035,
    },
    {
        lat: 47.465,
        lng: 10.035,
    },
    {
        lat: 47.46,
        lng: 10.015,
    },
    {
        lat: 47.465,
        lng: 9.99,
    },
    {
        lat: 47.475,
        lng: 9.975,
    },
    {
        lat: 47.495,
        lng: 9.97,
    },
    {
        lat: 47.515,
        lng: 9.945,
    },
    {
        lat: 47.51,
        lng: 9.91,
    },
    {
        lat: 47.525,
        lng: 9.895,
    },
    {
        lat: 47.51,
        lng: 9.885,
    },
    {
        lat: 47.51,
        lng: 9.86,
    },
    {
        lat: 47.525,
        lng: 9.835,
    },
    {
        lat: 47.525,
        lng: 9.815,
    },
    {
        lat: 47.54,
        lng: 9.795,
    },
    {
        lat: 47.575,
        lng: 9.8,
    },
    {
        lat: 47.575,
        lng: 9.785,
    },
    {
        lat: 47.555,
        lng: 9.765,
    },
    {
        lat: 47.515,
        lng: 9.745,
    },
    {
        lat: 47.52,
        lng: 9.54,
    },
    {
        lat: 47.53,
        lng: 9.53,
    },
    {
        lat: 47.55,
        lng: 9.535,
    },
    {
        lat: 47.605,
        lng: 9.595,
    },
];
